var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/profile_stats.tsx";
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { HStack, Text } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
import { shortNumberFormat } from 'soapbox/utils/numbers';
const messages = defineMessages({
  followers: {
    "id": "account.followers",
    "defaultMessage": "Followers"
  },
  follows: {
    "id": "account.follows",
    "defaultMessage": "Follows"
  }
});
/** Display follower and following counts for an account. */
const ProfileStats = ({
  account,
  onClickHandler
}) => {
  const intl = useIntl();
  const isMe = useAppSelector(state => state.me === account.id);
  const FollowersWrapper = React.useMemo(() => ({
    children
  }) => !isMe && account.pleroma?.get('hide_followers') ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(NavLink, {
    to: `/@${account.acct}/followers`,
    onClick: onClickHandler,
    title: !isMe && account.pleroma?.get('hide_followers_count') ? null : intl.formatNumber(account.followers_count),
    className: "hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 95
    }
  }, children), [account, onClickHandler, intl]);
  const FollowingWrapper = React.useMemo(() => ({
    children
  }) => !isMe && account.pleroma?.get('hide_follows') ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : /*#__PURE__*/React.createElement(NavLink, {
    to: `/@${account.acct}/following`,
    onClick: onClickHandler,
    title: !isMe && account.pleroma?.get('hide_follows_count') ? null : intl.formatNumber(account.following_count),
    className: "hover:underline",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 93
    }
  }, children), [account, onClickHandler, intl]);
  if (!account) {
    return null;
  }
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FollowersWrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "primary",
    weight: "bold",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  }, account.pleroma?.get('hide_followers_count') ? '-' : shortNumberFormat(account.followers_count)), /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.followers)))), /*#__PURE__*/React.createElement(FollowingWrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "primary",
    weight: "bold",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 11
    }
  }, account.pleroma?.get('hide_follows_count') ? '-' : shortNumberFormat(account.following_count)), /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 11
    }
  }, intl.formatMessage(messages.follows)))));
};
export default ProfileStats;